export const view02ImageOptions = {
  angle: 'view02',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    BathingPlatform: 1,
    TeakOnBathingPlatform: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    CockpitTable: 1,
    SelfTacker: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: 'BathingPlatform'
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view02.js